"use client";

import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import HomeCard from "@/src/components/main-site/home/custom-mui/home-card/home-card";
import SectionHeader from "@/src/components/main-site/home/section-header/section-header";
import MainContent from "@/src/components/main-site/home/slider/main-content/main-content";
import {Box} from "@mui/material";
import {Navigation, Pagination} from "swiper/modules";

export default function LatestArticleSection({articles}: { articles: any[] }) {
    return (
        <section id="articles" style={{padding: "1rem 0"}}>
            <HomeCard id="article-container">
                <SectionHeader
                    title="Latest Articles"
                    subtitle="Stay updated with our latest articles covering technology, lifestyle, and wellness trends."
                />
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{clickable: true}}
                    spaceBetween={20}
                    slidesPerView={1}
                    slidesPerGroup={4}
                    breakpoints={{
                        640: {slidesPerView: 1},
                        768: {slidesPerView: 2},
                        1024: {slidesPerView: 3},
                        1280: {slidesPerView: 4},
                    }}
                >
                    {articles.map((article) => (
                        <SwiperSlide key={article?.id}>
                            <Box sx={{
                                backgroundColor: (theme) => theme.palette.custom?.homeSliderCardBackground,
                                padding: 1,
                                borderRadius: '8px',
                            }}>
                                <MainContent
                                    title={article?.title}
                                    subtitle={article.authors ? article.authors?.map((author: any) => `${author['first_name']} ${author['last_name']}`).join(', ') : ''}
                                    img={article.feature_image ? process.env.NEXT_PUBLIC_SERVICE_URI_CDN_SERVE + article.feature_image : null}
                                    url={'/articles/' + article?.journal.meta_data?.title_abbr + '-' + article?.id}
                                />
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </HomeCard>
        </section>
    );
}